// extracted by mini-css-extract-plugin
export default {"container":"view-map_container__3FiS4","label":"view-map_label__34oUs","icon":"view-map_icon__2pB0D","circle":"view-map_circle__2dazz"};